<template>
  <div class="property_wrap">
    <div class="pro_top">图片设置</div>
    <div style="padding:20px 0;">
    <el-form ref="form" label-width="80px">
      <el-form-item label="图片:">
        <el-upload
                class="addicon"
                :action="actionUrl"
                :data="data_"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                >
          <img v-if="form.pic" :src="form.pic" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <p class="imgdesc-bottomline">(图片大小不超过10M，1M以内不压缩，1M以上将压缩至20%大小，支持jpg、png格式)</p>
      </el-form-item>
    </el-form>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";
  export default {
    props: ["property"],
    data() {
      return {
        actionUrl:api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        form: {
          label: '',
          pic: ''
        }
      };
    },
    watch: {
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
    },
    methods: {
      handleAvatarSuccess(res, file) {
        // this.form.pic = URL.createObjectURL(file.raw);
        if (res.code === 0) {
          this.form.pic = res.path
          this.$message({
            message: '上传成功',
          });
        } else {
          this.$message.error(res.msg);
        }
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 10MB!');
        }
        return isLt2M;
      }
    }
  };
</script>

